import React, { useEffect, useRef, useState } from 'react';

import { Flex, useOutsideClick } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import useOneOnOnePageParams from 'screens/oneOnOneRabbit/hooks/useOneOnOnePageParams';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { InputV2 } from 'uiToolkitV1/InputV2';

import { OneOnOneActionItemCreateOrUpdateI, useCreateActionItemMutation } from '../hooks/dataHook';

export const createActionItemObject = ({
  agendaText,
  displayName,
  profilePhoto,
  userId,
  designation,
  employeeFunction,
}: {
  agendaText: string;
  displayName: string;
  profilePhoto: string;
  userId: string;
  designation: string;
  employeeFunction: string;
}): OneOnOneActionItemCreateOrUpdateI => ({
  actionItemText: agendaText,
  status: 'ACTIVE',
  toIds: [
    {
      id: Number(userId),
      displayName,
      profilePhoto,
      designation,
      employeeFunction,
      ownerType: 'OWNER',
    },
  ],
  detailedStatus: 'ONGOING',
});

interface Props {
  setCreatingInitiative: (creatingInitiative: boolean) => void;
}

const CreateInitiative = ({ setCreatingInitiative }: Props) => {
  const { masterId, instanceId } = useOneOnOnePageParams();

  const createActionItemMutation = useCreateActionItemMutation({
    masterId,
    instanceId,
  });
  const loggedInEmployeeData = useSelector(selectLoggedInEmployeeData);

  const inputRef = useRef<HTMLInputElement>(null);

  const [actionItemText, setActionItemText] = useState('');

  const createAgendaHandler = async (agendaText: string) => {
    if (!agendaText || agendaText.trim() === '') {
      setCreatingInitiative(false);
      return;
    }
    try {
      const newActionItem = createActionItemObject({
        agendaText,
        displayName: loggedInEmployeeData?.displayName,
        profilePhoto: loggedInEmployeeData?.profilePhotoSrc,
        designation: loggedInEmployeeData?.designation,
        employeeFunction: loggedInEmployeeData?.employeeFunction,
        userId: loggedInEmployeeData?.id,
      });
      createActionItemMutation.mutate({
        updatedActionItem: newActionItem,
        onMutation: () => setCreatingInitiative(false),
      });
    } catch (e) {
      console.error('Error creating agenda : ', e);
    } finally {
      // setCreatingAgenda(false);
    }
  };
  const handleAgendaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setActionItemText(e.target.value);
  };

  useOutsideClick({
    ref: inputRef,
    handler: () => createAgendaHandler(actionItemText),
  });

  const onEnterPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      createAgendaHandler(actionItemText);
    }
  };
  //   focus on input when component mounts
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <Flex
      p="18px 16px"
      sx={{
        backgroundColor: '#F6FAFE',
      }}
      w="100%"
      minHeight="115px"
      alignItems="center"
    >
      <InputV2
        ref={inputRef}
        isDashed
        value={actionItemText}
        onChange={handleAgendaChange}
        onKeyDown={onEnterPress}
        data-testid="create-initiative-input"
      />
    </Flex>
  );
};

export { CreateInitiative };
